import React, { useEffect, useState } from 'react';
import dataAids from '../../../../constants/dataAids';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import { errorMessageProps } from '../../../../constants/constants';
import * as Metrics from '../../utils/trackMetric';
import * as MetricEvents from '../../../../constants/metrics';

const InventoryWarning = props => {
  const {
    product,
    translate,
    priceTable,
    selectedVariant,
    productErrorMessages,
    isSelectedVariantInStock
  } = props;

  const lowInventoryThreshold = product?.low_inventory_threshold || 3;
  const variantData = priceTable[selectedVariant] || {};
  const quantityErrors = productErrorMessages('quantity');
  const styles = {
    error: {
      marginBottom: 'small'
    }
  };

  const [lowInventoryText, setLowInventoryText] = useState('');

  useEffect(() => {
    if (variantData.totalOnHand <= lowInventoryThreshold && variantData.totalOnHand > 0) {
      Metrics.track(MetricEvents.LOW_INVENTORY_ALMOST_GONE_IMPRESSION);
      setLowInventoryText(translate('products.item_low_quantity_almost_gone'));
    }
  }, [variantData, lowInventoryThreshold]);

  if (!product || !product.track_inventory) {
    return null;
  }

  if (quantityErrors.length) {
    return <UX2.Element.Error { ...errorMessageProps } children={ quantityErrors[0] } />;
  } else if (!isSelectedVariantInStock && !product.backorderable) {
    return (
      <UX2.Element.Error
        { ...errorMessageProps }
        data-aid={ dataAids.OUT_OF_STOCK }
        children={ translate('products.item_out_of_stock_v2') }
        style={ styles.error }
      />
    );
  } else if (variantData.totalOnHand <= lowInventoryThreshold && variantData.totalOnHand > 0) {
    return (
      <UX2.Element.Error
        { ...errorMessageProps }
        data-aid={ dataAids.LOW_INVENTORY_ALERT_RENDERED }
        children={ lowInventoryText }
        style={ styles.error }
      />
    );
  }

  return null;
};

InventoryWarning.propTypes = {
  product: PropTypes.object,
  translate: PropTypes.func,
  priceTable: PropTypes.object,
  selectedVariant: PropTypes.number,
  productErrorMessages: PropTypes.func,
  isSelectedVariantInStock: PropTypes.bool
};

export default InventoryWarning;
